import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

// Components
import AlertMessage from '../../../../../../components/AlertMessage';

// Thunks
import { getActiveNfListStatus } from '../../../../../../redux/tracking';
import { getActiveNFListStatusUI } from '../../../../../../redux/selectors';

import './styles.css';
import SingleStatus from '../../../../../../components/StatusFlow/singleStatus';
import InfoTitle from '../../components/InfoTitle';
import SkeletonStatus from '../components/Skeleton';

import {
  TMSStepTypes,
  TMSStepTypesTranskey,
  WMSStepTypes,
  WMSStepTypesTranskey,
} from '../../../TrackingNFList/NewTrackingNFItem/StatusFlow/enums';

import { 
  StatusValues,
} from './enums';
import { ContainerTitle } from './styles';

class TrackingDetailsTimeline extends Component {
  componentDidMount() {
    this._getNFListStatus();
  }

  _getNFListStatus = () => {
    const { dispatch, data } = this.props;
    dispatch(getActiveNfListStatus(data));
  };

  _renderTimeline = nfStatusList => {
    return (
      <React.Fragment>
        {nfStatusList && (
          <>
            {nfStatusList.wms && nfStatusList.wms.length > 0 ? (
              <Fragment>
                {nfStatusList.wms.map((item, index) => (
                  <SingleStatus
                    key={`${item.statusType}-${item.changedStatusAt}`}
                    data={item}
                    isWMS
                    changedStatusAt={item.changedStatusAt}
                    title={WMSStepTypesTranskey[item.stepType]}
                    first={index === 0}
                    stepType={item.stepType}
                    statusType={item.statusType}
                    branchName={item.branchName}
                    finishDate={item.finishDate}
                    notHired={item.stepType === WMSStepTypes.NOT_INCLUDED} // Armazém não contratado
                    notStarted={item.statusType === StatusValues.NOT_STARTED} // 1
                    onHold={item.statusType === StatusValues.ON_HOLD} // 2
                    inProgress={item.statusType === StatusValues.IN_PROGRESS} // 3
                    completed={item.statusType === StatusValues.COMPLETED} // 4
                    vertical
                  />
                ))}
              </Fragment>
            ) : (
              <SingleStatus
                title={WMSStepTypesTranskey[WMSStepTypes.NOT_INCLUDED]}
                stepType={WMSStepTypes.CANCELED}
                first
                vertical
              />
            )}
            {nfStatusList.tms && nfStatusList.tms.length > 0 ? (
              <Fragment>
                {(() => {
                  const processedTms = [];
                  const transferSteps = [];
                  const arrivalSteps = [];
                  let inTransferGroup = false;

                  const flushTransferGroup = () => {
                    if (!inTransferGroup) return;
                    const transfers = transferSteps.map((t, i) => ({
                      branchName: t.branchName,
                      changedStatusAt: t.changedStatusAt,
                      arrivalBranch: arrivalSteps[i] || null,
                    }));
                    processedTms.push({
                      ...transferSteps[0],
                      statusType: transferSteps[transferSteps.length - 1].statusType,
                      changedStatusAt: transferSteps[transferSteps.length - 1].changedStatusAt,
                      transfers,
                    });
                    transferSteps.length = 0;
                    arrivalSteps.length = 0;
                    inTransferGroup = false;
                  };

                  nfStatusList.tms.forEach(item => {
                    if (item.stepType === TMSStepTypes.TRANSFER_DELIVERY) {
                      inTransferGroup = true;
                      transferSteps.push(item);
                    } else if (item.stepType === TMSStepTypes.ARRIVAL_BRANCH && inTransferGroup) {
                      arrivalSteps.push(item);
                    } else {
                      flushTransferGroup();
                      processedTms.push({ ...item });
                    }
                  });
                  flushTransferGroup();

                  return processedTms.map((item, index) => (
                    <SingleStatus
                      key={`${item.statusType}-${item.changedStatusAt}`}
                      data={item}
                      deliveryType={item.deliveryType}
                      changedStatusAt={item.changedStatusAt}
                      title={TMSStepTypesTranskey[item.stepType]}
                      last={index === processedTms.length - 1}
                      stepType={item.stepType}
                      statusType={item.statusType}
                      branchName={item.branchName}
                      transfers={item.transfers}
                      notHired={item.stepType === TMSStepTypes.NOT_INCLUDED}
                      transfer={item.stepType === TMSStepTypes.TRANSFER_DELIVERY}
                      notStarted={item.statusType === StatusValues.NOT_STARTED}
                      onHold={item.statusType === StatusValues.ON_HOLD}
                      inProgress={item.statusType === StatusValues.IN_PROGRESS}
                      completed={item.statusType === StatusValues.COMPLETED}
                      vertical
                    />
                  ));
                })()}
              </Fragment>
            ) : (
              <SingleStatus
                title={WMSStepTypesTranskey[WMSStepTypes.NOT_INCLUDED]}
                stepType={WMSStepTypes.CANCELED}
                first
                vertical
              />
            )}
          </>
        )}
      </React.Fragment>
    )
  };

  render() {
    const { className, nfStatusList, ui } = this.props;

    return (
      <div className={`TrackingDetailsTimeline ${className || ''}`}>
        <ContainerTitle>
          <InfoTitle>Status</InfoTitle>
        </ContainerTitle>
        {ui.isFetching && (
          <SkeletonStatus />
        )}
        {ui.error && (
          <AlertMessage
            className="TrackingDetailsTimeline__error-message"
            error
            message={ui.error}
            actionText="Tentar novamente"
            onRetry={this._getNFListStatus}
          />
        )}
        {!ui.isFetching && !ui.error && this._renderTimeline(nfStatusList)}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    nfStatusList: state.tracking.activeNfListStatus.data,
    ui: getActiveNFListStatusUI(state),
  };
}

export default connect(mapStateToProps)(TrackingDetailsTimeline);
